import { useParams } from "react-router";
import { DaWrongDevice } from "../../components/DaWrongDevice";

function DaWrongDeveicePage() {
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <div className={theme} data-testid="theme-name">
      {tenant === "ms1" ? <DaWrongDevice /> : null}
    </div>
  );
}

export default DaWrongDeveicePage;
